import { useSyncExternalStore } from "react";
import { getViewAsLibraryId, subscribeViewAsLibrary, } from "../utils/viewAsLibrary";
export var useViewAsLibraryId = function () {
    return useSyncExternalStore(subscribeViewAsLibrary, getViewAsLibraryId);
};
